<mat-dialog-content>
  <lemon-dialog-header> Muistutus </lemon-dialog-header>

  <form novalidate style="margin: 0">
    <div class="dark-gray-text" style="width: 400px; padding-left: 3em; padding-right: 3em">
      <p>Asiakas on hyvä kontaktoida jos tauko jatkuu pitkään. Tauko on nyt kestänyt {{ tauonKesto() }}.</p>
      <p>Valitse seuraava muistutusajankohta:</p>

      <mat-form-field style="max-width: 200px; margin-right: 10px">
        <mat-label>Muistutuspvm</mat-label>
        <input name="Muistutuspvm" type="text" [matDatepicker]="pickerMuistutus" [formField]="lomake.muistutuspvm" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="pickerMuistutus"></mat-datepicker-toggle>
        @if (naytaVirhe(lomake.muistutuspvm, 'required')) {
          <mat-error> Muistutuspäivä puuttuu </mat-error>
        }
        @if (naytaVirhe(lomake.muistutuspvm, 'minDate')) {
          <mat-error> Pvm pitää olla tulevaisuudessa </mat-error>
        }
        <mat-datepicker #pickerMuistutus></mat-datepicker>
      </mat-form-field>

      <!-- <i class="icon ion-ios-information-circle-outline info" [matTooltip]="muistutusPvmText" aria-hidden="true"></i> -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Tauko muistutus: Peruuta ja sulje dialog">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Tauko muistutus tallennettu" [actionContext]="[$any(lomake().value())]">Tallenna</app-primary-button>
</mat-dialog-actions>
